import * as React from "react";
import InternalSelect, { ISelectProps } from "./Select";
import Option from "./Option";
import SelectAction from "./SelectAction";

interface ISelectType extends React.FC<ISelectProps> {
  Option: typeof Option;
  Action: typeof SelectAction;
}

export const Select = InternalSelect as ISelectType;

Select.Option = Option;
Select.Action = SelectAction;

export default Select;
